import { render, staticRenderFns } from "./SpecialBiwako202507.vue?vue&type=template&id=4826640e&scoped=true"
import script from "./SpecialBiwako202507.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202507.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202507.vue?vue&type=style&index=0&id=4826640e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826640e",
  null
  
)

export default component.exports